// Measures fetched by the KPI page's campaign-media query (the
// `media_campaigns` source in connect.ts). Kept in its own module (no React /
// hook imports) so the coverage spec can assert every catalog key with source
// `media_campaigns` is fetched — a key present in the catalog but missing
// from this list silently renders 0 for every date (the same silent-zero
// failure mode the revenue_kpi_table coverage spec guards for `metrics.*`).
export const MEDIA_CAMPAIGNS_QUERY_MEASURES = [
  "company_media_metrics_campaigns.modeled_revenue",
  "company_media_metrics_campaigns.modeled_revenue_over_spend",
  "company_media_metrics_campaigns.estimated_d180_brand_value",
  "company_media_metrics_campaigns.modeled_brand_value_over_spend",
  "company_media_metrics_campaigns.meta_ads_modeled_revenue",
  "company_media_metrics_campaigns.meta_ads_modeled_revenue_over_spend",
  "company_media_metrics_campaigns.meta_ads_modeled_brand_value",
  "company_media_metrics_campaigns.meta_ads_modeled_brand_value_over_spend",
  "company_media_metrics_campaigns.youtube_ads_modeled_revenue",
  "company_media_metrics_campaigns.youtube_ads_modeled_revenue_over_spend",
  "company_media_metrics_campaigns.youtube_ads_modeled_brand_value",
  "company_media_metrics_campaigns.youtube_ads_modeled_brand_value_over_spend",
  "company_media_metrics_campaigns.google_ads_modeled_revenue",
  "company_media_metrics_campaigns.google_ads_modeled_revenue_over_spend",
  "company_media_metrics_campaigns.google_ads_modeled_brand_value",
  "company_media_metrics_campaigns.google_ads_modeled_brand_value_over_spend",
  "company_media_metrics_campaigns.tiktok_ads_modeled_revenue",
  "company_media_metrics_campaigns.tiktok_ads_modeled_revenue_over_spend",
  "company_media_metrics_campaigns.tiktok_ads_modeled_brand_value",
  "company_media_metrics_campaigns.tiktok_ads_modeled_brand_value_over_spend",
  "company_media_metrics_campaigns.pinterest_ads_modeled_revenue",
  "company_media_metrics_campaigns.pinterest_ads_modeled_revenue_over_spend",
  "company_media_metrics_campaigns.pinterest_ads_modeled_brand_value",
  "company_media_metrics_campaigns.pinterest_ads_modeled_brand_value_over_spend",
]
